import { IndicationItem } from 'features/indicationTriage'

/**
 * Parses a DRA rating string (e.g., 'GR-DRA-1', 'GR-DRA-2') and extracts the numeric level.
 *
 * @param draString - The DRA rating string to parse
 * @returns The numeric DRA level, or undefined if the string is invalid
 */
export const parseDraRating = (
  draString: string | undefined
): number | undefined => {
  if (!draString || typeof draString !== 'string') return undefined
  const match = draString.match(/GR-DRA-(\d+)/)
  return match ? parseInt(match[1], 10) : undefined
}

/**
 * Finds the worst (highest) DRA rating from a list of indications.
 * DRA ratings are stored in customInfo.dra_rating as strings like 'GR-DRA-1', 'GR-DRA-2', etc.
 *
 * @param indications - The indications to search through
 * @returns The highest DRA level found, or undefined if none found
 */
export const getWorstDraFromIndications = (
  indications: ReadonlyArray<IndicationItem>
): number | undefined => {
  const draRatings = indications
    .map((indication) => {
      const customInfo = indication.customInfo as
        | { dra_rating?: string }
        | undefined
      return parseDraRating(customInfo?.dra_rating)
    })
    .filter((rating): rating is number => rating !== undefined)

  return draRatings.length > 0 ? Math.max(...draRatings) : undefined
}
